function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import generalRouteSubRouteService from '@rd-web-markets/shared/dist/services/general_route_subroute.service';
import React, { useCallback, useEffect, useState } from 'react';
const employeeService = {
  useImportStatus(projectElsterDetailId) {
    const [data, setData] = useState([]);
    const [importStatus, setImportStatus] = useState({});
    const [intervalId, setIntervalId] = useState(null);
    const getImportStatus = useErrorHandling(useCallback(async () => {
      const response = await this.get(projectElsterDetailId, 'import_staff_cost_template');
      if (response === null) {
        setImportStatus({
          import_status: 'never_imported'
        });
      } else {
        setImportStatus(_objectSpread({}, response));
      }
      if ((response === null || response === void 0 ? void 0 : response.import_status) !== 'pending') {
        employeeService.useGetStaffCost(setData, projectElsterDetailId);
      }
      return response;
    }, [projectElsterDetailId]));
    const importTemplate = useErrorHandling(useCallback(async body => {
      const response = await this.postFormData(projectElsterDetailId, body);
      setImportStatus(_objectSpread({}, response));
    }, [projectElsterDetailId]));
    useEffect(() => {
      if (importStatus.import_status === 'pending' && !intervalId) {
        const currentId = setInterval(() => {
          getImportStatus();
        }, 2000);
        setIntervalId(currentId);
      } else if (importStatus.import_status !== 'pending' && !!intervalId) {
        clearInterval(intervalId);
        setIntervalId(null);
      }
      return () => {
        clearInterval(intervalId);
      };
    }, [getImportStatus, importStatus.import_status, intervalId, projectElsterDetailId]);
    useEffect(() => {
      getImportStatus();
    }, [getImportStatus]);
    return [data, setData, importStatus, importTemplate];
  },
  async useGetStaffCost(setData, projectElsterDetailId) {
    const response = await this.get(projectElsterDetailId, 'staff_costs');
    setData([...response]);
  },
  useExportTemplate(projectElsterDetailId) {
    window.open("/api/project_elster_details/".concat(projectElsterDetailId, "/export_staff_cost_template"));
  },
  get(projectElsterDetailId, subRoute) {
    return generalRouteSubRouteService.getAll(projectElsterDetailId, 'project_elster_details', subRoute);
  },
  postFormData(projectElsterDetailId, body) {
    return generalRouteSubRouteService.postFormData(projectElsterDetailId, 'project_elster_details', 'import_staff_cost_template', body);
  }
};
export default employeeService;